var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.97016C0 15.4627 4.52381 20 10 20C15.4762 20 20 15.4627 20 9.97016C20 4.47761 15.4762 0 10 0C4.52381 0 0 4.47761 0 9.97016ZM13.6905 14.6268C11.369 13.1941 8.3929 12.8358 4.94048 13.6119C4.10714 13.7313 3.9881 12.5373 4.70238 12.4179C8.5119 11.5224 11.7262 11.9403 14.3452 13.5522C15 13.9702 14.3452 14.9851 13.6905 14.6268ZM14.7024 11.9403C12.0238 10.2686 7.91667 9.79103 4.7619 10.7463C3.75 11.0448 3.39286 9.49254 4.34524 9.25373C7.97619 8.17913 12.4405 8.71643 15.5357 10.6268C16.369 11.1642 15.5357 12.4776 14.7024 11.9403ZM4.28571 7.70148C3.27381 8.05968 2.61905 6.32835 3.75 5.91044C7.2619 4.83582 13.2143 5.01492 16.9048 7.22387C17.9167 7.76118 16.9643 9.43286 15.8929 8.83579C12.6786 6.92536 7.32143 6.74626 4.28571 7.70148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.0bce3fe5047ed28b11c605e43f46cd4d.svg";
export { ForwardRef as ReactComponent };